module.exports = __webpack_public_path__ + "img/messages-bubble-square.e3da19ca.svg";